import { all, call, put, takeLatest } from 'redux-saga/effects';
import { get } from '../../../services/api';

import {
  userEndpoint,
  contentCommunitiesEndpoint
} from '../../../services/endpoint';

import {
  FETCH_USER_COMMUNITIES_REQUEST,
  FETCH_USER_REQUEST,
  fetchUserCommunitiesFailure,
  fetchUserCommunitiesSuccess,
  fetchUserFailure,
  fetchUserSuccess
} from '../../actions/user/userActions';
import { normaliseCommunities } from '../../utils/utils';

export function* fetchUserSaga() {
  try {
    const res = yield call(get, userEndpoint());
    // this condition is to catch false positives (where we get 200 ok from the api)
    if (res.id) {
      yield put(fetchUserSuccess(res));
    } else {
      yield put(fetchUserFailure(res));
    }
  } catch (err) {
    const { response = {} } = err;
    yield put(fetchUserFailure(response));
  }
}

export function* fetchUserCommunitiesSaga(action) {
  const { contentId } = action.payload;
  try {
    const res = yield call(get, contentCommunitiesEndpoint(contentId));
    if (Array.isArray(res)) {
      const normalisedCommunities = normaliseCommunities(res);
      yield put(fetchUserCommunitiesSuccess(normalisedCommunities));
    } else {
      yield put(fetchUserCommunitiesFailure(res));
    }
  } catch (e) {
    const { response = {} } = e;
    yield put(fetchUserCommunitiesFailure(response));
  }
}

export default function* root() {
  yield all([
    yield takeLatest(FETCH_USER_REQUEST, fetchUserSaga),
    yield takeLatest(FETCH_USER_COMMUNITIES_REQUEST, fetchUserCommunitiesSaga)
  ]);
}
